import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow, Transition as _Transition, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../static/images/xia.png'
import _imports_1 from '../../static/images/xinp.png'
import _imports_2 from '../../static/images/play.png'


const _withScopeId = n => (_pushScopeId("data-v-03b5e99e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "banner",
  ref: "bannerRef"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "txt padding" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "了解更多", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cir" }, [
  /*#__PURE__*/_createElementVNode("i")
], -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "了解更多", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cir" }, [
  /*#__PURE__*/_createElementVNode("i")
], -1))
const _hoisted_11 = { class: "tools" }
const _hoisted_12 = { class: "sub" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_14 = {
  src: _imports_0,
  alt: "",
  class: "xia"
}
const _hoisted_15 = {
  class: "h-ab padding",
  id: "h-ab"
}
const _hoisted_16 = { class: "title" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "关于我们", -1))
const _hoisted_18 = { class: "desc" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "了解更多", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cir" }, [
  /*#__PURE__*/_createElementVNode("i")
], -1))
const _hoisted_21 = { class: "ab-bg" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "items padding" }
const _hoisted_24 = { class: "item gd" }
const _hoisted_25 = { class: "num" }
const _hoisted_26 = ["data-num"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "项", -1))
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "item gd" }
const _hoisted_30 = { class: "num" }
const _hoisted_31 = ["data-num"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "座", -1))
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "item gd" }
const _hoisted_35 = { class: "num" }
const _hoisted_36 = ["data-num"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "+万", -1))
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "item gd" }
const _hoisted_40 = { class: "num" }
const _hoisted_41 = ["data-num"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "+", -1))
const _hoisted_43 = ["src"]
const _hoisted_44 = {
  class: "h-pro padding",
  ref: "spanItemRef"
}
const _hoisted_45 = { class: "circle" }
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "t" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "产品详情", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cir" }, [
  /*#__PURE__*/_createElementVNode("i")
], -1))
const _hoisted_52 = { class: "news padding" }
const _hoisted_53 = { class: "flex" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "新闻资讯"),
  /*#__PURE__*/_createElementVNode("p", null, "公司/行业相关信息一手掌握")
], -1))
const _hoisted_55 = { class: "fx" }
const _hoisted_56 = { class: "news-tab" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "了解更多", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cir" }, [
  /*#__PURE__*/_createElementVNode("i")
], -1))
const _hoisted_60 = { class: "news-items" }
const _hoisted_61 = { class: "img" }
const _hoisted_62 = ["src"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "meng" }, null, -1))
const _hoisted_64 = { class: "txt" }
const _hoisted_65 = { class: "time" }
const _hoisted_66 = {
  class: "h-video",
  ref: "videoRef"
}
const _hoisted_67 = /*#__PURE__*/_createStaticVNode("<div class=\"meng\" data-v-03b5e99e><div class=\"m\" data-v-03b5e99e></div><div class=\"m\" data-v-03b5e99e></div><div class=\"m\" data-v-03b5e99e></div><div class=\"m\" data-v-03b5e99e></div></div>", 1)
const _hoisted_68 = { class: "img" }
const _hoisted_69 = ["src"]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = ["poster", "src"]
const _hoisted_73 = { class: "h-links padding" }
const _hoisted_74 = ["src"]
const _hoisted_75 = { class: "txt" }
const _hoisted_76 = ["innerHTML"]
const _hoisted_77 = {
  href: "https://www.zhipin.com/gongsir/fdc8e2e6d3238c3d1n1739i-EVA~.html?ka=company-jobs",
  class: "item"
}
const _hoisted_78 = ["src"]
const _hoisted_79 = { class: "txt" }
const _hoisted_80 = ["innerHTML"]
const _hoisted_81 = ["src"]
const _hoisted_82 = { class: "txt" }
const _hoisted_83 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_Footer = _resolveComponent("Footer")!
  const _directive_scroll_to = _resolveDirective("scroll-to")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_swiper, {
        class: "swp-banner",
        autoplay: _ctx.swiperBanner.autoplay,
        speed: _ctx.swiperBanner.speed,
        loop: _ctx.swiperBanner.loop,
        pagination: _ctx.swiperBanner.pagination,
        modules: _ctx.modules
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bannerList, (item) => {
            return (_openBlock(), _createBlock(_component_swiper_slide, {
              key: item.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: item.image,
                  alt: "",
                  class: "img"
                }, null, 8, _hoisted_2),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("h5", null, _toDisplayString(item.title), 1),
                  _createElementVNode("h3", {
                    innerHTML: item.text
                  }, null, 8, _hoisted_4),
                  (item.id == 9)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: item.url,
                        target: "_blank",
                        class: "more gd"
                      }, _hoisted_8, 8, _hoisted_5))
                    : (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: item.url,
                        class: "more gd"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9,
                          _hoisted_10
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["autoplay", "speed", "loop", "pagination", "modules"]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createElementVNode("img", _hoisted_14, null, 512), [
            [_directive_scroll_to, '#h-ab']
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("h5", null, _toDisplayString(_ctx.about.title), 1)
      ]),
      _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.about.text), 1),
      _createVNode(_component_router_link, {
        to: "/about",
        class: "more border gd"
      }, {
        default: _withCtx(() => [
          _hoisted_19,
          _hoisted_20
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("img", {
        src: _ctx.about.image,
        alt: "",
        class: "bg"
      }, null, 8, _hoisted_22),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("span", {
                ref: "spanRef1",
                "data-num": _ctx.aboutRjzl.text
              }, _toDisplayString(_ctx.num1), 9, _hoisted_26),
              _hoisted_27
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.aboutRjzl.title), 1)
          ]),
          _createElementVNode("img", {
            src: _ctx.aboutRjzl.image,
            alt: "",
            class: "icon"
          }, null, 8, _hoisted_28)
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("span", {
                ref: "spanRef2",
                "data-num": _ctx.aboutZhgc.text
              }, _toDisplayString(_ctx.num2), 9, _hoisted_31),
              _hoisted_32
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.aboutZhgc.title), 1)
          ]),
          _createElementVNode("img", {
            src: _ctx.aboutZhgc.image,
            alt: "",
            class: "icon"
          }, null, 8, _hoisted_33)
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("span", {
                ref: "spanRef3",
                "data-num": _ctx.aboutFwrq.text
              }, _toDisplayString(_ctx.num3), 9, _hoisted_36),
              _hoisted_37
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.aboutFwrq.title), 1)
          ]),
          _createElementVNode("img", {
            src: _ctx.aboutFwrq.image,
            alt: "",
            class: "icon"
          }, null, 8, _hoisted_38)
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("span", {
                ref: "spanRef4",
                "data-num": _ctx.aboutFwst.text
              }, _toDisplayString(_ctx.num4), 9, _hoisted_41),
              _hoisted_42
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.aboutFwst.title), 1)
          ]),
          _createElementVNode("img", {
            src: _ctx.aboutFwst.image,
            alt: "",
            class: "icon"
          }, null, 8, _hoisted_43)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_44, [
      _createVNode(_component_swiper, {
        class: "swp-pro",
        navigation: _ctx.swiperPro.navigation,
        modules: _ctx.modulesPro
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productList, (item) => {
            return (_openBlock(), _createBlock(_component_swiper_slide, {
              key: item.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("img", {
                    src: item.index_image,
                    alt: ""
                  }, null, 8, _hoisted_46)
                ]),
                _createElementVNode("h6", null, _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("span", null, _toDisplayString(item.index_tx), 1)
                ]),
                _createElementVNode("div", {
                  class: "bark",
                  innerHTML: item.index_text
                }, null, 8, _hoisted_49),
                _createVNode(_component_router_link, {
                  to: { path: '/product-detail/' + item.id },
                  class: "more border gd"
                }, {
                  default: _withCtx(() => [
                    _hoisted_50,
                    _hoisted_51
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["navigation", "modules"])
    ], 512),
    _createElementVNode("div", _hoisted_52, [
      _createElementVNode("div", _hoisted_53, [
        _hoisted_54,
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newsList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: _normalizeClass(_ctx.newsIndex == index ? 'li gd active' : 'li gd'),
                onClick: ($event: any) => (_ctx.newsMouseover(index))
              }, _toDisplayString(item.name), 11, _hoisted_57))
            }), 128))
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newsList, (item, index) => {
            return _withDirectives((_openBlock(), _createBlock(_component_router_link, {
              to: { path: '/news', query: {id: item.id} },
              class: "more border gd",
              key: item.id
            }, {
              default: _withCtx(() => [
                _hoisted_58,
                _hoisted_59
              ]),
              _: 2
            }, 1032, ["to"])), [
              [_vShow, _ctx.newsIndex == index]
            ])
          }), 128))
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newsList, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "list",
          key: item.id
        }, [
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_60, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (row, i) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    to: { path: '/news-detail/' + row.id },
                    class: _normalizeClass(i == 0 ? index == 0 ? 'item item1 s-r-left' : 'item item1' : (i == 1 ? index == 0 ? 'item item2 s-r-right' : 'item item2' : index == 0 ? 'item s-r-bottom' : 'item')),
                    key: row.id
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("img", {
                          src: row.image,
                          alt: "",
                          class: "gd"
                        }, null, 8, _hoisted_62)
                      ]),
                      _hoisted_63,
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("h6", null, _toDisplayString(row.title), 1),
                        _createElementVNode("div", _hoisted_65, "时间：" + _toDisplayString(_ctx.common.formatTime(row.publishtime + '000')), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to", "class"]))
                }), 128))
              ], 512), [
                [_vShow, _ctx.newsIndex == index]
              ])
            ]),
            _: 2
          }, 1024)
        ]))
      }), 128))
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_66, [
      _hoisted_67,
      _createElementVNode("div", _hoisted_68, [
        _createElementVNode("img", {
          src: _ctx.indexVideo.image,
          alt: ""
        }, null, 8, _hoisted_69)
      ]),
      _createElementVNode("div", {
        class: "play",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openVideo && _ctx.openVideo(...args)))
      }, _hoisted_71)
    ], 512), [
      [_vShow, _ctx.indexVideo.file]
    ]),
    _createVNode(_Transition, { name: "el-fade-in" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: "video-box",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeVideo && _ctx.closeVideo(...args)))
        }, [
          _createElementVNode("video", {
            poster: _ctx.indexVideo.image,
            src: _ctx.indexVideo.file,
            controls: "",
            ref: "vdRef"
          }, null, 8, _hoisted_72)
        ], 512), [
          [_vShow, _ctx.videoShow]
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_73, [
      _createVNode(_component_router_link, {
        to: "/culture",
        class: "item"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _ctx.qywh.image,
            alt: ""
          }, null, 8, _hoisted_74),
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("h6", null, _toDisplayString(_ctx.qywh.title), 1),
            _createElementVNode("div", {
              class: "desc",
              innerHTML: _ctx.qywh.text
            }, null, 8, _hoisted_76)
          ])
        ]),
        _: 1
      }),
      _createElementVNode("a", _hoisted_77, [
        _createElementVNode("img", {
          src: _ctx.rczp.image,
          alt: ""
        }, null, 8, _hoisted_78),
        _createElementVNode("div", _hoisted_79, [
          _createElementVNode("h6", null, _toDisplayString(_ctx.rczp.title), 1),
          _createElementVNode("div", {
            class: "desc",
            innerHTML: _ctx.rczp.text
          }, null, 8, _hoisted_80)
        ])
      ]),
      _createVNode(_component_router_link, {
        to: "/contact",
        class: "item"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _ctx.lxwm.image,
            alt: ""
          }, null, 8, _hoisted_81),
          _createElementVNode("div", _hoisted_82, [
            _createElementVNode("h6", null, _toDisplayString(_ctx.lxwm.title), 1),
            _createElementVNode("div", {
              class: "desc",
              innerHTML: _ctx.lxwm.text
            }, null, 8, _hoisted_83)
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Footer)
  ], 64))
}